import styled, { css } from 'styled-components';
import Image from 'next/image';
import { Breakpoints } from '../../../../styled/constants';
import {
  FlexColumn,
  FlexibleDiv,
  multilineEllipsis
} from '../../../../styled/common';
import { Typography } from '../../../ui/Typography';
import { tagStyles } from '../../../ui/Typography/styles';
import { ResidenceSectionTitle } from '../ResidenceSection/styled';

export const infrastructureSectionStyles = css`
  padding: 30px 15px;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    padding: 30px 40px;

    ${ResidenceSectionTitle} {
      ${tagStyles.h3};
      line-height: 20px;
      margin-bottom: 10px;
    }
  }
`;

export const InfrastructureBlockDescription = styled(Typography)`
  display: none;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    display: block;
    margin-bottom: 20px;
    color: ${({ theme }) => theme.colors.text.secondary};
  }
`;

export const InfrastructuresContainer = styled(FlexibleDiv)`
  margin: 0 -15px;
  overflow-x: auto;
  gap: 15px;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (min-width: ${Breakpoints.tablet}px) {
    gap: 20px;
    margin: 0 -40px;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin: 0;
    overflow: visible;
  }

  @media (min-width: ${Breakpoints.desktop}px) {
    grid-template-columns: repeat(5, 225px);
    column-gap: calc((100% - 225px * 5) / 4);
    row-gap: 30px;
  }
`;

export const Infrastructure = styled(FlexColumn)`
  width: 120px;
  box-sizing: border-box;
  flex: 0 0 auto;

  &:first-of-type {
    margin-left: 15px;
  }

  &:last-of-type {
    margin-right: 15px;
  }

  @media (min-width: ${Breakpoints.tablet}px) {
    width: 225px;

    &:first-of-type {
      margin-left: 40px;
    }

    &:last-of-type {
      margin-right: 40px;
    }
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    width: 100%;

    &:first-of-type {
      margin-left: 0;
    }

    &:last-of-type {
      margin-right: 0;
    }
  }

  @media (min-width: ${Breakpoints.desktop}px) {
    width: 225px;
  }
`;

export const InfrastructureImage = styled(Image)`
  width: 100%;
  height: 120px;
  border-radius: 7px;
  overflow: hidden;
  object-fit: cover;

  @media (min-width: ${Breakpoints.tablet}px) {
    height: 170px;
  }
`;

export const InfrastructureTitle = styled(Typography)`
  display: block;
  margin: 15px 0 4px;
  ${multilineEllipsis()};

  @media (min-width: ${Breakpoints.tablet}px) {
    ${tagStyles.title_3_desc}
  }
`;

export const InfrastructureDescriptionWrapper = styled(FlexibleDiv)`
  gap: 5px;
  align-items: center;
  margin-top: auto;
`;

export const InfrastructureDescription = styled(Typography)`
  color: ${({ theme }) => theme.colors.text.secondary};
`;
